<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
          <i class="bi bi-lock" (click)="bulkUpdateObjectInfoLocking(true)" *ngIf="isLockAll"></i>
          <i class="bi bi-unlock" (click)="bulkUpdateObjectInfoLocking(false)" *ngIf="isUnLockAll"></i>
          <div class="search">
            <form autocomplete="off">
              <input type="text" placeholder="search" (keyup.enter)="getObjectInfoByWildSearchWithPagination(0,10)"
                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
            </form>
            <i class="bi bi-search" (click)="getObjectInfoByWildSearchWithPagination(0,10)"></i>
          </div>
          <button data-toggle="modal" *ngIf="actionControls.isAdd" title="Add Asset" data-target="#deviceModal"><i
              class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
          <!-- <button data-toggle="modal" title="Clone Asset" data-target="#cloneDeviceModal"><i class="bi bi-plus-lg"></i> Clone</button> -->

          <div class="filter-icon">
            <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i>
            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 table-data" [ngClass]="{'col-lg-9 col-md-9 ': showFilter}">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 5%;" *ngIf="isShowLock"></th>
                <th style="width: 9%;" *ngIf="isShowLock">{{ 'object-info.objectInfoId' | translate }}</th>
                <th style="width: 14%;" *ngIf="!isShowLock">{{ 'object-info.objectInfoId' | translate }}</th>
                <th style="width: 13%;">{{ 'object-info.givenName' | translate }}</th>
                <th style="width: 13%;">{{ 'object-info.zone' | translate }}</th>
                <th style="width: 13%;">{{ 'object-info.latestHolding' | translate }}</th>
                <th style="width: 13%;">{{ 'object-info.objectCondition' | translate }}</th>
                <th style="width: 14%;">{{ 'object-info.createdDate' | translate }}</th>
                <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.objectInfoId == recordId }"
              *ngFor="let list of objectInfoListWithPagination | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">
              <p style="width: 5%;overflow: hidden;padding-right: 0;" *ngIf="isShowLock">
                <input type="checkbox" [(ngModel)]="list.lock" (click)="selectAssetForLock(list.objectInfoId)">
              </p>
              <p style="width: 9%;" *ngIf="isShowLock">{{list.objectInfoId}}</p>
              <p style="width: 14%;" *ngIf="!isShowLock">{{list.objectInfoId}}</p>
              <p style="width: 13%;" title="{{list.givenName}}">{{list.givenName || '--'}}</p>
              <p style="width: 13%;">{{list.zone || '--'}}</p>
              <p style="width: 13%;cursor: pointer;" data-toggle="modal" data-target="#viewHoldingModal"
                (click)="getObjectInfoById(list.objectInfoId,'view')">{{list.latestHolding?.name || '--'}}</p>
              <p style="width: 13%;">{{assetCondition(list.objectCondition)}}</p>
              <p style="width: 14%;">{{list.createdDate | date}}</p>
              <p class="action-buttons" style="width: 20%;">
                <i data-toggle="modal" *ngIf="actionControls.isView" title="View and Repair"
                  (click)="getObjectInfoById(list.objectInfoId,'view')" data-target="#viewModal"
                  class="bi bi-eye-fill"></i>
                <i class="bi bi-pencil-square" *ngIf="actionControls.isModify"
                  (click)="getObjectInfoById(list.objectInfoId,'edit')" data-toggle="modal"
                  data-target="#editModal"></i>
                <i (click)="selectDelete(list.id,list)" *ngIf="actionControls.isDelete" title="Delete"
                  class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
                <i data-toggle="modal" title="Clone Asset" *ngIf="actionControls.isAdd" data-target="#cloneDeviceModal"
                  (click)="cloneObjectInfoById(list.objectInfoId)" class="bi bi-copy"></i>
              </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && objectInfoListWithPagination.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
              [totalRecords]="count" [showFirstLastIcon]="true" [showCurrentPageReport]="true" [showPageLinks]="true"
              [showJumpToPageDropdown]="false" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>
        <div class="col-lg-3 col-md-3" *ngIf="showFilter">
          <div class="filter-block">
            <div class="filters">
              <div class="filter-title">
                <p>{{ 'filters.filter' | translate }}</p>
                <div class="filter-apply-button">
                  <button (click)="resetFilter()">{{ 'filters.reset' | translate }}</button>
                  <button (click)="applyFilter()">{{ 'filters.apply' | translate }}</button>
                </div>
              </div>


              <div class="filter-section">

                <!-- Model -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'modelFilter'"
                      (change)="onFilterSelect('modelFilter')" />
                    {{ 'filters.model' | translate }}
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="modelFilter" [disabled]="!modelChecked" />
                </div>

                <!-- Make -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'makeFilter'"
                      (change)="onFilterSelect('makeFilter')" />
                    {{ 'filters.make' | translate }}
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="makeFilter" [disabled]="!makeChecked" />
                </div>

                <!-- Type -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'typeFilter'"
                      (change)="onFilterSelect('typeFilter')" />
                    {{ 'filters.type' | translate }}
                  </label>
                  <select class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked">
                    <option value="" selected disabled> -- Select Type --</option>
                    <option value="{{object.typeName}}" *ngFor="let object of objectTypeData;let i = index">
                      {{object.typeName}}</option>
                  </select>
                  <!-- <input type="text" class="form-control" [(ngModel)]="typeFilter" [disabled]="!typeChecked" /> -->
                </div>

                <!-- Group -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'groupFilter'"
                      (change)="onFilterSelect('groupFilter')" />
                    {{ 'filters.group' | translate }}
                  </label>

                  <select class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked">
                    <option value="" selected disabled> -- Select Group --</option>
                    <option value="{{object.groupName}}" *ngFor="let object of objectGroupData;let i = index">
                      {{object.groupName}}</option>
                  </select>
                  <!-- <input type="text" class="form-control" [(ngModel)]="groupFilter" [disabled]="!groupChecked" /> -->
                </div>

                <!-- Serial Number -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'serialNumberFilter'"
                      (change)="onFilterSelect('serialNumberFilter')" />
                    {{ 'filters.serialNumber' | translate }}
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="serialNumberFilter"
                    [disabled]="!serialNumberChecked" />
                </div>

                <!-- Object Condition -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'objectConditionFilter'"
                      (change)="onFilterSelect('objectConditionFilter')" />
                    {{ 'filters.assetCondition' | translate }}
                  </label>
                  <select class="form-control" [(ngModel)]="objectConditionFilter" [disabled]="!objectConditionChecked">
                    <option value="" disabled selected>-- Select Condition --</option>
                    <option value="Good">Good</option>
                    <option value="UnderRepair">Under Repair</option>
                    <option value="Scrap">Scrap</option>
                  </select>
                </div>

                <!-- Branch -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'branchFilter'"
                      (change)="onFilterSelect('branchFilter')" />
                    {{ 'filters.branch' | translate }}
                  </label>
                  <select name="" id="" [(ngModel)]="branchFilter" [disabled]="!branchChecked" class="form-control">
                    <option value="" selected disabled> -- Select Branch --</option>
                    <option value="{{list.name}}" *ngFor="let list of branchFilterList">{{list.name}}</option>
                  </select>
                  <!-- <input type="text" class="form-control" [(ngModel)]="branchFilter" [disabled]="!branchChecked" /> -->
                </div>

                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'locationFilter'"
                      (change)="onFilterSelect('locationFilter')" />
                    {{ 'filters.location' | translate }}
                  </label>
                  <select name="" id="" [(ngModel)]="locationFilter" [disabled]="!locationChecked" class="form-control">
                    <option value="" selected disabled> -- Select Location --</option>
                    <option value="{{list.zone}}" *ngFor="let list of locationFilterList">{{list.zone}} - {{list.city}}
                      - {{list.postalCode}}</option>
                  </select>
                </div>

                <!-- Department -->
                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'departmentFilter'"
                      (change)="onFilterSelect('departmentFilter')" />
                    {{ 'filters.department' | translate }}
                  </label>
                  <select name="" id="" [(ngModel)]="departmentFilter" [disabled]="!departmentChecked"
                    class="form-control">
                    <option value="" selected disabled> -- Select Department--</option>
                    <option value="{{list.departmentName}}" *ngFor="let list of departmentFilterList">
                      {{list.departmentName}}</option>
                  </select>
                </div>


                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'lockFilter'"
                      (change)="onFilterSelect('lockFilter')" />
                    {{ 'filters.lock' | translate }}
                  </label>
                  <select name="" id="" [(ngModel)]="lockFilter" [disabled]="!lockChecked" class="form-control">
                    <option value="" selected disabled> -- Select Lock --</option>
                    <option [ngValue]="true">Lock</option>
                    <option [ngValue]="false">Un Lock</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>
                    <input type="radio" name="filter" [checked]="selectedFilter === 'parentAssetFilter'"
                      (change)="onFilterSelect('parentAssetFilter')" />
                    Parent Assets
                  </label>
                  <select name="" id="" [(ngModel)]="parentAssetFilter" [disabled]="!parentAssetChecked"
                    class="form-control">
                    <option value="" selected disabled> -- Select Asset--</option>
                    <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoListFilter">{{list.givenName}}
                    </option>
                  </select>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <label>{{ 'object-info.name' | translate }} <span class="required">*</span></label>
            <select name="" id="" [(ngModel)]="objectTemplateId" class="form-control"
              (change)="getObjectTemplateById($event)">
              <option value="" selected disabled> -- Asset Template--</option>
              <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
            </select>
          </div>

          <div *ngFor="let list of singleObjectTemplateData">

            <div class="form-group">
              <label>{{ 'object-info.givenName' | translate }} <span class="required">*</span></label>
              <input type="text" (contextmenu)="$event.preventDefault()" (blur)="trimValue('givenName')" (cut)="false"
                (keydown)="filterInputByType($event, 'allText')" class="form-control" [(ngModel)]="givenName">
            </div>

            <div class="form-group" *ngIf="list.originalCost">
              <label>{{ 'object-info.originalCost' | translate }} <span class="required"
                  *ngIf="isOriginalCost">*</span></label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="originalCost">
            </div>

            <div class="form-group" *ngIf="list.currentCost">
              <label>{{ 'object-info.currentCost' | translate }} </label>
              <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="currentCost">
            </div>

            <div class="form-group">
              <label>{{ 'object-info.objectCondition' | translate }} <span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="objectCondition" class="form-control"
                (change)="objectConditionChange()">
                <option value="" disabled> -- Select Condition --</option>
                <option *ngFor="let condition of assetConditions" [value]="condition.value">{{ condition.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'object-info.assetStatus' | translate }}</label>
              <select name="" id="" [(ngModel)]="assetStatus" class="form-control">
                <option value=""> -- </option>
                <option *ngFor="let list of assetStatusList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>
            <!-- 
            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.asset_Category' | translate }} <span class="required"
                  *ngIf="isAsset_Category">*</span></label>
              <select name="" id="" [(ngModel)]="asset_Category" class="form-control">
                <option value="" selected disabled> -- Select Asset Category--</option>
                <option value="{{list.categoryName}}" *ngFor="let list of objectCategoryList">{{list.categoryName}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.acquisitionDate' | translate }}</label>
              <input type="date" (keydown)="filterDateInput($event)" class="form-control" [(ngModel)]="acquisitionDate">
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.salvageValue' | translate }} <span class="required"
                  *ngIf="isSalvageValue">*</span></label>
              <input type="number" class="form-control" [(ngModel)]="salvageValue">
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.depreciationMethod' | translate }}</label>
              <select name="" id="" [(ngModel)]="depreciationMethod"
                (change)="depreciationMethodChange(depreciationMethod)" class="form-control">
                <option value="" selected disabled> -- Select Asset Depreciation--</option>
                <option value="{{list.assetDepreciationMethodId}}" *ngFor="let list of assetDepreciationDataList">
                  {{list.methodName}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.putToUseDate' | translate }} <span class="required"
                  *ngIf="isPutToUseDate">*</span></label>
              <input type="date" [max]="todayDate" (keydown)="filterDateInput($event)" class="form-control"
                [(ngModel)]="putToUseDate">
            </div>

            <div class="form-group" *ngIf="list.depreciationRequired">
              <label>{{ 'object-info.assetLifeNumber' | translate }} <span class="required"
                  *ngIf="isAssetLifeNumber">*</span></label>
              <input type="number" class="form-control" (paste)="false" (contextmenu)="$event.preventDefault()"
                (cut)="false" (keydown)="filterInputByType($event, 'number')" [(ngModel)]="assetLifeNumber">
            </div> -->

            <div class="form-group" *ngIf="list.branch">
              <label>{{ 'object-info.branch' | translate }}</label>
              <select name="" id="" [(ngModel)]="branch" class="form-control">
                <option value="" selected disabled> -- select branch --</option>
                <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.department">
              <label>{{ 'object-info.department' | translate }}</label>
              <select name="" id="" [(ngModel)]="department" class="form-control">
                <option value="" selected disabled> -- select department--</option>
                <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">{{list.departmentName}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.make">
              <label>{{ 'object-info.make' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('make')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="make">
            </div>

            <div class="form-group" *ngIf="list.model">
              <label>{{ 'object-info.model' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('model')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="model">
            </div>

            <div class="form-group" *ngIf="list.serialNumber">
              <label>{{ 'object-info.serialNumber' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('serialNumber')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="serialNumber">
            </div>








            <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="objectQty">
            </div>

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectUOM' | translate }}</label>
              <select class="form-control" [(ngModel)]="objectUOM" [ngModelOptions]="{standalone: true}">
                <option value="" selected disabled> -- Select Uom --</option>
                <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}</option>
              </select>
            </div> -->

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.availableQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="availableQty">
            </div> -->










            <div class="form-group">
              <label>{{ 'object-info.location' | translate }} <span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="location" (change)="locationChange(location)" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{loc.zone}}" *ngFor="let loc of locationFilterList">{{loc.zone}} - {{loc.city}} -
                  {{loc.postalCode}}</option>
              </select>
            </div>

            <!-- <div class="form-group">
              <label>Asset Status</label>
              <select name="" id="" [(ngModel)]="objectStatus" class="form-control">
                <option value="" selected disabled> -- select location --</option>
                <option value="{{list.city}}" *ngFor="let list of locationList">{{list.city}}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Asset Status Color</label>
              <input type="text" [(ngModel)]="objectStatusColor" class="form-control">
            </div> -->

            <div class="map-frame">
              <div id="map">
              </div>
              <div class="map-latlng" *ngIf="isLatLng">
                <button (click)="removeLatLng()">{{ 'generic.remove' | translate }}</button>
              </div>
            </div>

            <div class="image-container" style="margin: 20px 0;">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.icon' | translate }}</h5>
                <i *ngIf="icon == ''" (click)="addIconBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block" *ngIf="icon != null && icon != ''">
                <div class="image-single">
                  <img src="{{icon}}" alt="">
                  <span (click)="removeIcon()">{{ 'generic.remove' | translate }}</span>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-icon-btn" accept="image/*" hidden="true"
                  (change)="onIconChange($event)">
              </div>

            </div>


            <div class="image-container">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.images' | translate }}</h5>
                <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block">

                <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                  <p>{{image.name}}</p>
                  <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                  <button (click)="removeImage(i)">{{ 'generic.remove' | translate }}</button>
                </div>
                <div class="large-image-view" *ngIf="largeImage != ''">
                  <img src="{{largeImage}}" alt="">
                  <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
                  (change)="onTicketChange($event)">
              </div>
            </div>









            <div class="check-box">
              <p>{{ 'maintenance-schedule.title' | translate }} <i (click)="addMaintenance()"
                  class="bi bi-plus-circle"></i></p>
            </div>

            <div class="maintenance-schedule-block">
              <!-- <h5>Maintenance Schedule</h5> -->
              <div class="maintenance-schedule" *ngFor="let list of maintenanceList;let index = index">
                <span class="remove"><i (click)="removeMaintenance(index)" class="bi bi-x-lg"></i></span>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.description' | translate }}</label>
                  <textarea name="" [(ngModel)]="list.description" (blur)="list.description = list.description.trim()"
                    (keydown)="filterInputByType($event, 'allText')" class="form-control" id=""></textarea>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.maintenanceType' | translate }}</label>
                  <select name="" id="" [(ngModel)]="list.maintenanceType" class="form-control">
                    <option value="" selected disabled> -- Select Maintenance Type --</option>
                    <option value="{{list.value}}" *ngFor="let list of maintenanceType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.frequency' | translate }}</label>
                  <select name="" id="" [(ngModel)]="list.frequency" class="form-control">
                    <option value="" selected disabled> -- Select Frequency Type --</option>
                    <option value="{{list.value}}" *ngFor="let list of frequencyType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.nextDueDate' | translate }}</label>
                  <input type="date" [min]="todayDate" class="form-control" [(ngModel)]="list.nextDueDate">
                </div>
              </div>
            </div>

            <div class="multiple-inputs"
              *ngIf="list.nameValue && list.nameValue != null && list.nameValue != undefined && list.nameValue.length != 0">
              <h5 class="multi-title">{{ 'object-info.specifications' | translate }}</h5>
              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.nameValue">
                  <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                      type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>
            </div>

            <div class="multiple-inputs"
              *ngIf="list.performanceMatrix && list.performanceMatrix != null && list.performanceMatrix != undefined && list.performanceMatrix.length != 0">
              <h5 class="multi-title">{{ 'object-info.performance' | translate }}</h5>

              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.performanceMatrix">
                  <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode1 let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                      type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>

            </div>







            <div class="multiple-inputs" *ngIf="list.warranty">
              <h5 class="multi-title">{{ 'object-info.warranty' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let warrantyInfo of list.warrantyInfo">
                  <strong>{{ warrantyInfo.key }}:</strong>
                  <span
                    *ngIf="warrantyInfo.key != 'Proof Of Purchase (Scan and Upload Bill or invoice etc)' && warrantyInfo.key != 'Coverage Start Date' && warrantyInfo.key != 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="text">
                  </span>
                  <span *ngIf="warrantyInfo.key == 'Coverage Start Date' || warrantyInfo.key == 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="date">
                  </span>
                  <span *ngIf="warrantyInfo.key == 'Proof Of Purchase (Scan and Upload Bill or invoice etc)'">
                    <!-- <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="file"> -->
                    <button (click)="addProofBtn()">{{ 'generic.file' | translate }}</button>
                    <input readonly type="text" class="file-name" *ngIf="proofFile && proofFile != ''"
                      value="{{proofFile}}">
                    <img *ngIf="proofFileType && proofFileType != ''" src="{{proofFilePath}}" alt="">
                    <!-- <span class="file-name" *ngIf="proofFile && proofFile != ''">{{proofFile}}</span> -->
                    <div hidden="true">
                      <input #proof type="file" id="add-proof-btn" hidden="true" (change)="onProofChange($event)">
                    </div>

                  </span>
                </li>
              </ul>
            </div>


            <div class="multiple-inputs" *ngIf="list.purchase">
              <h5 class="multi-title">{{ 'object-info.purchase' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let purchaseInfo of list.purchaseInfo">
                  <strong>{{ purchaseInfo.key }}:</strong>
                  <span *ngIf="purchaseInfo.key != 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                      style="width: 100%;" type="text"></span>
                  <span *ngIf="purchaseInfo.key == 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                      style="width: 100%;" type="date"></span>
                </li>
              </ul>
            </div>






            <div class="check-box">
              <p><input type="checkbox" (click)="selectConnection($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetMonitoring" [(ngModel)]="assetMonitoring"> {{ 'object-info.assetMonitoring' |
                translate }}</p>
            </div>


            <div class="nameValue" *ngIf="assetMonitoring">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringFrequency' | translate }}</label>
                    <input [(ngModel)]="assetMonitoringFrequency" [ngModelOptions]="{standalone: true}" type="number"
                      class="form-control">
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringTimeSpan' | translate }} </label>
                    <input [(ngModel)]="assetMonitoringTimeSpan" [ngModelOptions]="{standalone: true}" type="number"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div>
                <h5 class="multi-title">{{ 'object-info.connections' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of connectionsList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                    <i class="bi bi-plus-circle" (click)="addConnection()"></i>
                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeConnection(i)"></i>
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                    <i class="bi bi-dash-circle" (click)="removeConnection(i)"></i>
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" (blur)="object.key = object.key.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" (blur)="object.value = object.value.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter value" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="nameValue" *ngIf="assetMonitoring">
              <div>
                <h5 class="multi-title">Add NMS</h5>

                <div class="row keys-content keysBlock" style="width: 99%;margin-left: auto;margin-right: auto;">

                  <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                      <label for="">{{ 'zabbix.groups' | translate }} <span class="required"> *</span></label>
                      <!-- <input [(ngModel)]="groups" [ngModelOptions]="{standalone: true}" placeholder="enter host"
                        type="text" class="form-control"> -->

                      <select name="" id="" class="form-control" [(ngModel)]="groups"
                        [ngModelOptions]="{standalone: true}">
                        <option value="">Select Group</option>
                        <option *ngFor="let group of zabbixGroups" [value]="group.groupid">{{ group.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.templates' | translate }} <span class="required"> *</span></label>
                      <!-- <input [(ngModel)]="templates" [ngModelOptions]="{standalone: true}" placeholder="enter template"
                        type="text" class="form-control"> -->

                      <select name="" id="" class="form-control" [(ngModel)]="templates"
                        [ngModelOptions]="{standalone: true}">
                        <option value="">Select Template</option>
                        <option *ngFor="let template of zabbixTemplates" [value]="template.templateid">{{ template.name
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.ip' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="ip" [ngModelOptions]="{standalone: true}" placeholder="enter ip" type="text"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.port' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="port" [ngModelOptions]="{standalone: true}" placeholder="enter port"
                        type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpCommunity' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="snmpCommunity" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp community" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpVersion' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="snmpVersion" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp version" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpContextName' | translate }}</label>
                      <input [(ngModel)]="snmpContextName" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp context name" type="text" class="form-control">
                    </div>

                    <div>


                    </div>
                  </div>
                </div>

              </div>






            </div>


            <div class="check-box">
              <p><input type="checkbox" (click)="selectAssetHealth($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetHealth" [(ngModel)]="assetHealth"> {{ 'object-info.assetHealth' | translate }}</p>
            </div>


            <div class="nameValue" *ngIf="assetHealth">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetHealth' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of assetHealthList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                    <i class="bi bi-plus-circle" (click)="addAssetHealth()"></i>
                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                    <i class="bi bi-dash-circle" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" (blur)="object.key = object.key.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" (blur)="object.value = object.value.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter value" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>





            <div class="check-box">
              <p><input type="checkbox" (click)="selectPerformance($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="performance" [(ngModel)]="performance"> {{ 'object-info.assetPerformance' | translate }}
              </p>
            </div>


            <div class="nameValue" *ngIf="performance">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                      <input [(ngModel)]="timeSpan" [ngModelOptions]="{standalone: true}" placeholder="enter time span"
                        type="text" class="form-control">
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.uom' | translate }}</label>
                      <select class="form-control" [(ngModel)]="uom" [ngModelOptions]="{standalone: true}">
                        <option value="" selected disabled> -- Select Uom --</option>
                        <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                      <input [(ngModel)]="expectedOutput" [ngModelOptions]="{standalone: true}"
                        placeholder="enter expected output" type="text" class="form-control">
                    </div>

                  </div>
                </div>
              </div>
            </div>



            <div class="check-box">
              <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deployCurrentLocation"
                  [(ngModel)]="deployCurrentLocation">{{ 'object-info.deployCurrentLocation' | translate }}</p>
            </div>

            <div class="check-box" *ngIf="parentAssetIdFlag">
              <p><input type="checkbox" (click)="selectParentAsset($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="isParentAssetId" [(ngModel)]="isParentAssetId">{{ 'object-info.parentAsset' | translate }}
              </p>
            </div>


            <div class="nameValue" *ngIf="isParentAssetId">
              <div>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.parentAsset' | translate }}</label>
                      <!-- <select name="" id="" [(ngModel)]="parentAssetId" class="form-control">
                        <option value="" selected disabled> -- select parent asset --</option>
                        <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                      </select> -->

                      <ng-multiselect-dropdown [placeholder]="'Select Dashboard'" [settings]="parentDropdownSettings"
                        [data]="objectInfoList" [(ngModel)]="parentSelectedList" class="form-control"
                        style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>





            <div class="check-box">
              <p>{{ 'object-info.tags' | translate }} <i (click)="addTag()" class="bi bi-plus-circle"></i></p>
            </div>

            <div class="tags-block">
              <div class="form-group tag" *ngFor="let list of tags;let index = index">
                <input type="text" placeholder="enter tag" [(ngModel)]="list.tag" class="form-control">
                <span class="remove"><i (click)="removeTag(index)" class="bi bi-x-lg"></i></span>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">{{ 'generic.add' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID: {{recordId}})”</span>?
        </p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton1" (click)="closeModal()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteAsset()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.detail' | translate }}
          <span class="header-action">
            <i class="bi bi-lock" (click)="updateObjectInfoLocking(false)" *ngIf="isLock"></i>
            <i class="bi bi-unlock" (click)="updateObjectInfoLocking(true)" *ngIf="!isLock"></i>
            <i class="bi bi-wrench-adjustable-circle" *ngIf="!isRepairGiven" (click)="openRepair()"></i>
            <i class="bi bi-x-lg" data-dismiss="modal" (click)="remove()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.objectInfoId' | translate }} :</label>
                <p>{{viewData.objectInfoId || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.name' | translate }} :</label>
                <p>{{viewData.name || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.givenName' | translate }} :</label>
                <p>{{viewData.givenName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
                <label>{{ 'object-info.serialNumber' | translate }} :</label>
                <p>{{viewData.serialNumber || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.group' | translate }} :</label>
                <p>{{viewData.group || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.type' | translate }} :</label>
                <p>{{viewData.type || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
                <label>{{ 'object-info.model' | translate }} :</label>
                <p>{{viewData.model || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
                <label>{{ 'object-info.make' | translate }} :</label>
                <p>{{viewData.make || '--'}}</p>
              </div>



              <div class="col-md-6 col-lg-6">
                <label>Asset Status :</label>
                <p>{{viewData.assetStatus || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
                <label>{{ 'object-info.originalCost' | translate }} :</label>
                <p>{{viewData.originalCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
                <label>{{ 'object-info.currentCost' | translate }} :</label>
                <p>{{viewData.currentCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
                <label>{{ 'object-info.branch' | translate }} :</label>
                <p>{{viewData.branch || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                <label>{{ 'object-info.department' | translate }} :</label>
                <p>{{viewData.department || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.location' | translate }} :</label>
                <p>{{viewData.location || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.country' | translate }} :</label>
                <p>{{viewData.country || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                <p>{{viewData.provinceOrState || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.zone' | translate }} :</label>
                <p>{{viewData.zone || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.postalCode' | translate }} :</label>
                <p>{{viewData.postalCode || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.city' | translate }} :</label>
                <p>{{viewData.city || '--'}}</p>
              </div>


              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.createdDate' | translate }} :</label>
                <p>{{viewData.createdDate | date}}</p>
              </div>

              <!-- <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
                <p>{{viewData.acquisitionDate || '--'}}</p>
              </div> -->

              <!-- <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>{{ 'object-info.salvageValue' | translate }} :</label>
                <p>{{viewData.salvageValue || '--'}}</p>
              </div> -->

              <div class="col-md-6 col-lg-6">
                <label>Quantity :</label>
                <p>{{viewData.objectQty || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Available Quantity :</label>
                <p>{{viewData.availableQty || '--'}}</p>
              </div>



              <!-- <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
                <p>{{viewData.depreciationMethod || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
                <p>{{viewData.assetLifeNumber || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.asset_Category' | translate }} :</label>
                <p>{{viewData.asset_Category || '--'}}</p>
              </div> -->

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-template.deploy' | translate }}</label>
                <p>{{viewData.deploy? 'Yes': 'No'}}</p>
              </div>




              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.alive' | translate }} </label>
                <p>{{viewData.alive? 'Yes': 'No'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.assetMonitoring">
                <label>{{ 'object-info.available' | translate }} </label>
                <p>{{zabbixAvailable || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.deployCurrentLocation' | translate }} </label>
                <p>{{viewData.deployCurrentLocation? 'Yes': 'No'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.objectCondition' | translate }} : <i
                    *ngIf="viewData.objectCondition == 'Good' || viewData.objectCondition == 'GOOD' || viewData.objectCondition == 'good'"
                    class="bi bi-pencil-square" (click)="editStatusClick()"></i></label>
                <p>{{assetCondition(viewData.objectCondition)}}</p>
              </div>

              <div class="col-md-12 col-lg-12 " *ngIf="isEditStatus">
                <div class="obj-status">
                  <div class="form-group">
                    <label for="">Status</label>
                    <input readonly [(ngModel)]="objStatus.issueStatus" [ngModelOptions]="{standalone: true}"
                      placeholder="enter expected output" type="text" class="form-control">
                  </div>

                  <!-- <div class="form-group" *ngIf="viewData.objectCondition == 'FAULTY' || viewData.objectCondition == 'Faulty'">
                    <label for="">Status</label>
                    <select name="" id="" class="form-control">
                      <option value="Good">Good</option>
                      <option value="UnderRepair">Under Repair</option>
                      <option value="Scrap">Scrap</option>
                      <option value="Faulty">Faulty</option>
                    </select>
                  </div> -->


                  <div class="form-group">
                    <label for="">Remarks</label>
                    <input [(ngModel)]="objStatus.remarks" [ngModelOptions]="{standalone: true}"
                      placeholder="enter remarks" type="text" class="form-control">
                  </div>

                  <div class="form-group submit-update">
                    <button (click)="editStatusClick()">Close</button>
                    <button (click)="updateObjectStatusRequest()">Update</button>
                  </div>

                </div>

              </div>

              <div class="col-md-12 col-lg-12 qr-code">
                <label>{{ 'object-info.qr_code' | translate }} :</label>

                <qrcode [qrdata]="jsonString" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
                <button class="print-b" data-toggle="modal" title="Print" data-target="#printModal"> Print</button>

              </div>

              <div class="col-md-12 col-lg-12" style="margin-top: 30px;">
                <div class="map-frame">
                  <div id="map3">
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12">
                <div class="image-container" style="margin: 20px 0;">
                  <div class="image-header image-header1">
                    <h5>{{ 'object-info.icon' | translate }}</h5>
                  </div>
                  <div class="image-content-block" *ngIf="icon != null && icon != ''">
                    <div class="image-single" style="height: fit-content;">
                      <img src="{{icon}}" alt="">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-md-12 col-lg-12">
                <div class="image-container" style="margin-top: 20px;">
                  <div class="image-header image-header1">
                    <h5>{{ 'object-info.images' | translate }}</h5>
                    <i (click)="addTicketImageBtn1()" class="bi bi-plus-circle"></i>
                  </div>


                  <div class="image-content-block">
                    <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                      <p title="{{image.name}}">{{image.name}}</p>
                      <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                      <button (click)="removeImage(i)" *ngIf="actionControls.isRemove">Remove</button>
                    </div>
                    <div class="large-image-view" *ngIf="largeImage != ''">
                      <img src="{{largeImage}}" alt="">
                      <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                    </div>
                  </div>

                  <div hidden="true">
                    <input #imageInput type="file" id="add-TicketImage-btn1" accept="image/*" hidden="true"
                      (change)="onTicketChange1($event)">
                  </div>

                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
                <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">

                <div class="list-block">
                  <ul class="ui-tree">
                    <ng-container *ngFor="let item of viewData.nameValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                    </ng-container>
                  </ul>

                  <ng-template #renderNode let-node>
                    <li>
                      <strong>{{ node.key }}:</strong> {{ node.value }}
                      <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                        <ng-container *ngFor="let child of node.keyValue">
                          <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12 col-lg-12"
                *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
                <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }} <span
                    (click)="editPerformanceMatrixClick()">update</span></h5>
              </div>
              <div class="col-md-12 col-lg-12" *ngIf="editPerformanceMatrix">
                <div class="multiple-inputs"
                  *ngIf="viewData.performanceMatrix && viewData.performanceMatrix != null && viewData.performanceMatrix != undefined && viewData.performanceMatrix.length != 0">

                  <ul class="ui-tree">
                    <ng-container *ngFor="let item of performanceMatrixList">
                      <ng-container *ngTemplateOutlet="renderNode2; context: { $implicit: item }"></ng-container>
                    </ng-container>
                  </ul>

                  <ng-template #renderNode2 let-node>
                    <li>
                      <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                          type="text"></span>
                      <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                        <ng-container *ngFor="let child of node.keyValue">
                          <ng-container *ngTemplateOutlet="renderNode2; context: { $implicit: child }"></ng-container>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>

                </div>
                <div class="buttons">
                  <button type="button" class="btn btn-secondary" (click)="editPerformanceMatrixClose()">{{
                    'generic.cancel' | translate }}</button>
                  <button type="button" class="btn btn-primary" (click)="updatePerformanceMatrix()">{{ 'generic.submit'
                    | translate }}</button>
                </div>
              </div>






              <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                <div class="list-block">
                  <ul class="ui-tree">
                    <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                      <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.purchase && userCred.userType == 'Accounts'">
                <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.purchase && userCred.userType == 'Accounts'">
                <div class="list-block">
                  <ul class="ui-tree">
                    <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                      <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-12 col-lg-12 data-list"
                *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0 && !editPerformanceMatrix">

                <div class="list-block">
                  <ul class="ui-tree">
                    <ng-container *ngFor="let item of viewData.performanceMatrix">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                    </ng-container>
                  </ul>

                  <ng-template #renderNode1 let-node>
                    <li>
                      <strong>{{ node.key }}:</strong> {{ node.value }}
                      <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                        <ng-container *ngFor="let child of node.keyValue">
                          <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="maintenanceScheduleList && maintenanceScheduleList.length != 0">
                <h5 class="maintenance-list-title">{{ 'maintenance-schedule.title' | translate }}</h5>

                <div class="maintenance-list-block">
                  <div class="list" *ngFor="let list of maintenanceScheduleList">

                    <div class="list1">
                      <div>
                        <label>{{ 'maintenance-schedule.maintenanceType' | translate }} :</label>
                        <p>{{getMaintenanceType(list.maintenanceType) || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.frequency' | translate }} :</label>
                        <p>{{list.frequency || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.nextDueDate' | translate }} :</label>
                        <p>{{list.nextDueDate || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.lastPerformed' | translate }} :</label>
                        <p>{{list.lastPerformed || '--'}}</p>
                      </div>
                    </div>
                    <div>
                      <label>{{ 'maintenance-schedule.description' | translate }} :</label>
                      <p>{{list.description || '--'}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" id="repairForm" *ngIf="isRepair" style="padding: 0;">
                <div class="repair-block" [formGroup]="repairInfoForm">
                  <h5>{{ 'object-info.addRepair' | translate }}</h5>
                  <div class="form-group">
                    <label>{{ 'object-info.description' | translate }} <span class="required">*</span></label>
                    <textarea name="" formControlName="description" id=""></textarea>
                  </div>


                  <div class="repair-dates">
                    <div class="form-group">
                      <label>{{ 'object-info.repairGivenTo' | translate }} <span class="required">*</span></label>
                      <input type="text" class="form-control" formControlName="repairGivenTo">
                    </div>

                    <div class="form-group">
                      <label>{{ 'object-info.userName' | translate }} <span class="required">*</span></label>
                      <input type="text" class="form-control" formControlName="userName">
                    </div>

                    <div class="form-group">
                      <label>{{ 'object-info.phNo' | translate }} <span class="required">*</span></label>
                      <input type="text" class="form-control" formControlName="phNo">

                    </div>

                    <div class="form-group">
                      <label>{{ 'object-info.emailId' | translate }} <span class="required">*</span></label>
                      <input type="text" class="form-control" formControlName="emailId">
                    </div>
                    <div class="form-group">
                      <label>{{ 'object-info.repairGivenDate' | translate }} <span class="required">*</span></label>
                      <input type="date" (change)="onGivenDateChange($event)" [max]="currentDate" class="form-control"
                        formControlName="repairGivenDate">
                    </div>

                    <div class="form-group">
                      <label>{{ 'object-info.repairExpectedEndDate' | translate }} <span
                          class="required">*</span></label>
                      <input type="date" [min]="minEndDate" class="form-control"
                        formControlName="repairExpectedEndDate">
                    </div>

                    <div class="form-group">
                      <label>{{ 'object-info.estRepairCost' | translate }} <span class="required">*</span></label>
                      <input type="text" class="form-control" formControlName="estRepairCost">
                    </div>
                  </div>



                  <div class="action-repair">
                    <button type="button" class="btn btn-secondary" (click)="closeRepair()">{{ 'generic.cancel' |
                      translate }}</button>
                    <button type="button" (click)="addRepairInfos(true)" class="btn btn-primary">{{ 'generic.add' |
                      translate }}</button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }} <span
                    *ngIf="viewData.givenRepair" (click)="openRepairDone()">{{ 'object-info.repairDone' | translate
                    }}</span></h5>

                <div class="repair-block" *ngIf="isRepairDone" [formGroup]="repairInfoForm">
                  <!-- <h5>{{ 'object-info.repairDone' | translate }}</h5> -->
                  <div class="form-group">
                    <label>{{ 'object-info.description' | translate }} <span class="required">*</span></label>
                    <textarea name="" formControlName="description" id=""></textarea>
                  </div>

                  <div class="form-group">
                    <label>{{ 'object-info.repairCost' | translate }} <span class="required">*</span></label>
                    <input type="text" class="form-control" formControlName="repairCost">
                  </div>

                  <div class="action-repair">
                    <button type="button" class="btn btn-secondary" (click)="closeRepairDone()">{{ 'generic.cancel' |
                      translate }}</button>
                    <button type="button" (click)="addRepairInfos(false)" class="btn btn-primary">{{
                      'object-info.repairDone' | translate }}</button>
                  </div>
                </div>


                <div class="repair-list-block">
                  <div class="list" *ngFor="let list of viewData.repairInfos">
                    <div>
                      <p><label>{{ 'object-info.description' | translate }} :</label> {{list.description || '--'}}</p>
                    </div>

                    <div class="dates">
                      <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo || '--'}}
                      </p>
                      <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                      <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                      <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                      <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate |
                        date}}</p>
                      <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label>
                        {{list.repairExpectedEndDate | date}}</p>
                      <p><label>{{ 'object-info.repairCost' | translate }} :</label> {{list.repairCost || '--'}}</p>
                      <p><label>{{ 'object-info.estRepairCost' | translate }} :</label> {{list.estRepairCost || '--'}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.assetMonitoring">
                <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                    <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                    <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                  </div>
                </div>

                <div class="row" *ngIf="viewData.connectionDetails && viewData.connectionDetails.length > 0">
                  <ng-container *ngFor="let connectionDetails of viewData.connectionDetails">
                    <div class="col-md-6 col-lg-6" *ngIf="connectionDetails.key || connectionDetails.value">
                      <label>{{connectionDetails.key || '--'}} :</label>
                      <p>{{connectionDetails.value || '--'}}</p>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.assetMonitoring && viewData.snmpMonitoring">
                <div class="nms-card">
                  <h5 class="repair-list-title"><i class="bi bi-hdd-network"></i> NMS Details</h5>
                  <div class="nms-grid">
                    <div class="nms-item">
                      <span class="nms-label">{{ 'zabbix.ip' | translate }}</span>
                      <span class="nms-value">{{viewData.snmpMonitoring.ip || '--'}}</span>
                    </div>
                    <div class="nms-item">
                      <span class="nms-label">{{ 'zabbix.port' | translate }}</span>
                      <span class="nms-value">{{viewData.snmpMonitoring.port || '--'}}</span>
                    </div>
                    <div class="nms-item">
                      <span class="nms-label">{{ 'zabbix.snmpCommunity' | translate }}</span>
                      <span class="nms-value">{{viewData.snmpMonitoring.snmpCommunity || '--'}}</span>
                    </div>
                    <div class="nms-item">
                      <span class="nms-label">{{ 'zabbix.snmpVersion' | translate }}</span>
                      <span class="nms-value">{{viewData.snmpMonitoring.snmpVersion || '--'}}</span>
                    </div>
                    <div class="nms-item">
                      <span class="nms-label">{{ 'zabbix.snmpContextName' | translate }}</span>
                      <span class="nms-value">{{viewData.snmpMonitoring.snmpContextName || '--'}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.assetMonitoring && viewData.snmpMonitoring">
                <div class="sync-btn">
                  <button class="btn btn-primary" (click)="nmsSync()">Sync</button>
                </div>
              </div>




              <div class="col-md-12 col-lg-12 switch-ports-wrapper"
                *ngIf="viewData.switchPorts && viewData.switchPorts.length > 0">
                <div class="card">
                  <div class="card-header">
                    <div class="title">
                      <div class="icon-box">
                        <i class="fa-solid fa-network-wired"></i>
                      </div>
                      <h2>Switch Ports</h2>
                    </div>
                    <div class="header-actions">
                      <!-- <div class="search-box">
                                <i class="fa-solid fa-magnifying-glass"></i>
                                <input type="text" placeholder="Search port..." />
                            </div>
                            <button class="filter-btn">
                                <i class="fa-solid fa-filter"></i>
                            </button> -->
                    </div>
                  </div>

                  <div class="table-wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th>Port Name</th>
                          <th>Port Index</th>
                          <th>Status</th>
                          <th>Zabbix Item ID</th>
                          <th>Last Updated</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let port of viewData.switchPorts">
                          <td>{{ port.portName || '--' }}</td>
                          <td>{{ port.portIndex || '--' }}</td>
                          <td>
                            <span class="badge"
                              [ngClass]="{'up': port.status === 'UP' || port.status === 'up', 'down': port.status === 'DOWN' || port.status === 'down'}">
                              ● {{ (port.status | uppercase) || '--' }}
                            </span>
                          </td>
                          <td>{{ port.zabbixItemId || '--' }}</td>
                          <td>{{ (port.lastUpdated | date:'medium') || '--' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="table-footer">
                    Showing 1 to {{ viewData.switchPorts.length }} of {{ viewData.switchPorts.length }} entries
                  </div>
                </div>
              </div>



              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

                <div class="row">
                  <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                    <label>{{assetHealthList.key || '--'}} :</label>
                    <p>{{assetHealthList.value || '--'}}</p>
                  </div>
                </div>
              </div>


              <!-- 
              <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                <h5 class="repair-list-title">Repair List <span *ngIf="viewData.givenRepair" (click)="openRepairDone()">Repair Done</span></h5>
                
                <div class="repair-block" *ngIf="isRepairDone" [formGroup]="repairInfoForm">
                  <h5>Repair Done</h5>
                  <div class="form-group">
                    <label>Description</label>
                    <textarea name="" formControlName="description" id=""></textarea>
                  </div>

                  

                  <div class="action-repair">
                    <button type="button" class="btn btn-secondary" (click)="closeRepairDone()">Cancel</button>
                    <button type="button" (click)="addRepairInfos(false)" class="btn btn-primary">Repair Done</button>
                  </div>
                </div>


                <div class="repair-list-block">
                  <div class="list" *ngFor="let list of viewData.repairInfos">
                    <div>
                      <p><label>Description :</label> {{list.description || '--'}}</p>
                    </div>

                    <div class="dates">
                      <p><label>Company :</label> {{list.repairGivenTo || '--'}}</p>
                      <p><label>Name :</label> {{list.userName || '--'}}</p>
                      <p><label>Mobile :</label> {{list.phNo || '--'}}</p>
                      <p><label>Email :</label> {{list.emailId || '--'}}</p>
                      <p><label>Given Date :</label> {{list.repairGivenDate | date}}</p>
                      <p><label>Expected End Date :</label> {{list.repairExpectedEndDate | date}}</p>
                    </div>
                  </div>
                </div>
              </div> -->



              <div class="nameValue" *ngIf="performance">
                <div>
                  <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                  <div class="row keys-content">

                    <div class="col-md-12 col-lg-12 keysBlock">
                      <div class="form-group">
                        <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                        <p>{{viewData.assetPerformance?.timeSpan}}</p>

                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.uom' | translate }}</label>
                        <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                        <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.tags && viewData.tags.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
                <div class="tag-list">
                  <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
                </div>
              </div>


              <div style="margin-top: 15px;" class="col-md-12 col-lg-12 switch-ports-wrapper"
                *ngIf="viewData.holding && viewData.holding.length > 0">
                <div class="card">
                  <div class="card-header">
                    <div class="title">
                      <div class="icon-box">
                        <i class="fa-solid fa-clipboard-list"></i>
                      </div>
                      <h2>{{ 'object-info.holdingDetails' | translate }}</h2>
                    </div>
                  </div>

                  <div class="table-wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th>{{ 'object-allocation-register.userId' | translate }}</th>
                          <th>{{ 'object-info.holding' | translate }}</th>
                          <th>{{ 'object-allocation-register.updatedDate' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let holding of viewData.holding">
                          <td>{{ holding.userId || '--' }}</td>
                          <td>{{ holding?.name || '--' }}</td>
                          <td>{{ (holding.date | date:'medium') || '--' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- <div class="table-footer">
                    Showing 1 to {{ viewData.holding.length }} of {{ viewData.holding.length }} entries
                  </div> -->
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.edit' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <label>{{ 'object-info.name' | translate }}</label>
            <select name="" id="" disabled [(ngModel)]="objectTemplateId" class="form-control">
              <option value="" selected disabled> -- Asset --</option>
              <option value="{{list.objectTemplateId}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
            </select>
          </div>

          <div *ngFor="let list of singleObjectTemplateData">

            <div class="form-group">
              <label>{{ 'object-info.givenName' | translate }} <span class="required">*</span></label>
              <input type="text" (contextmenu)="$event.preventDefault()" (blur)="trimValue('givenName')"
                (keydown)="filterInputByType($event, 'allText')" (cut)="false" class="form-control"
                [(ngModel)]="givenName">
            </div>

            <div class="form-group read-only" *ngIf="originalCostCheckBox">
              <label>{{ 'object-info.originalCost' | translate }} <span class="required"
                  *ngIf="isOriginalCost">*</span></label>
              <input type="text" readonly class="form-control" [(ngModel)]="originalCost">
            </div>

            <div class="form-group" *ngIf="currentCostCheckBox">
              <label>{{ 'object-info.currentCost' | translate }}</label>
              <input type="text" (contextmenu)="$event.preventDefault()" (cut)="false"
                (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="currentCost">
            </div>

            <div class="form-group read-only">
              <label>{{ 'object-info.objectCondition' | translate }} <span class="required">*</span></label>
              <select name="" id="" disabled [(ngModel)]="objectCondition" class="form-control">
                <option value="" selected disabled> -- Select Condition --</option>
                <option value="Good">Good</option>
                <option value="UnderRepair">Under Repair</option>
                <option value="Scrap">Scrap</option>
                <option value="Faulty">Faulty</option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ 'object-info.assetStatus' | translate }}</label>
              <select name="" id="" [(ngModel)]="assetStatus" class="form-control">
                <option value=""> -- </option>
                <option *ngFor="let list of assetStatusList" [value]="list.name">{{ list.name }}</option>
              </select>
            </div>
            <!-- 
            <div class="form-group read-only" *ngIf="depreciationCheckbox">
              <label>{{ 'object-info.asset_Category' | translate }} <span class="required"
                  *ngIf="isAsset_Category">*</span></label>
              <select name="" id="" disabled [(ngModel)]="asset_Category" class="form-control">
                <option value="" selected disabled> -- Select Asset Category--</option>
                <option value="{{list.categoryName}}" *ngFor="let list of objectCategoryList">{{list.categoryName}}
                </option>
              </select>
            </div>

            <div class="form-group read-only" *ngIf="depreciationCheckbox">
              <label>{{ 'object-info.acquisitionDate' | translate }}</label>
              <input type="date" readonly class="form-control" [(ngModel)]="acquisitionDate">
            </div>

            <div class="form-group " *ngIf="depreciationCheckbox">
              <label>{{ 'object-info.salvageValue' | translate }} <span class="required"
                  *ngIf="isSalvageValue">*</span></label>
              <input type="number" readonly class="form-control" [(ngModel)]="salvageValue">
            </div>

            <div class="form-group" *ngIf="depreciationCheckbox">
              <label>{{ 'object-info.depreciationMethod' | translate }}</label>
              <select name="" id="" disabled [(ngModel)]="depreciationMethod" class="form-control">
                <option value="" selected disabled> -- Select Asset Depreciation--</option>
                <option value="{{list.assetDepreciationMethodId}}" *ngFor="let list of assetDepreciationDataList">
                  {{list.methodName}}</option>
              </select>
            </div>

            <div class="form-group read-only" *ngIf="depreciationCheckbox">
              <label>{{ 'object-info.assetLifeNumber' | translate }} <span class="required"
                  *ngIf="isAssetLifeNumber">*</span></label>
              <input type="number" readonly class="form-control" [(ngModel)]="assetLifeNumber">
            </div> -->

            <div class="form-group" *ngIf="list.branch">
              <label>{{ 'object-info.branch' | translate }}</label>
              <select name="" id="" [(ngModel)]="branch" class="form-control">
                <option value="" selected disabled> -- Select Branch --</option>
                <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.department">
              <label>{{ 'object-info.department' | translate }}</label>
              <select name="" id="" [(ngModel)]="department" class="form-control">
                <option value="" selected disabled> -- Select Department--</option>
                <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">{{list.departmentName}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="list.make">
              <label>{{ 'object-info.make' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('make')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="make">
            </div>

            <div class="form-group" *ngIf="list.model">
              <label>{{ 'object-info.model' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('model')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="model">
            </div>

            <div class="form-group" *ngIf="list.serialNumber">
              <label>{{ 'object-info.serialNumber' | translate }}</label>
              <input type="text" class="form-control" (blur)="trimValue('serialNumber')"
                (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="serialNumber">
            </div>


            <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectQty' | translate }}</label>
              <input type="text" class="form-control" disabled readonly [(ngModel)]="objectQty">
            </div>

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.objectUOM' | translate }}</label>
              <select class="form-control" [(ngModel)]="objectUOM" [ngModelOptions]="{standalone: true}">
                <option value="" selected disabled> -- Select Uom --</option>
                <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}</option>
              </select>
            </div> -->

            <!-- <div class="form-group" *ngIf="list.quantity">
              <label>{{ 'object-info.availableQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="availableQty">
            </div> -->

            <div class="form-group ">
              <label>{{ 'object-info.zone' | translate }} <span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="location" (change)="locationChange(location)" class="form-control">
                <option value="" selected disabled> -- Select Location --</option>
                <option value="{{list.zone}}" *ngFor="let list of locationFilterList">{{list.zone}} - {{list.city}} -
                  {{list.postalCode}}</option>
              </select>
            </div>



            <div class="form-group" *ngIf="isObjectColorCode">
              <label>{{ 'object-info.assetColor' | translate }}</label>
              <div class="asset-color">
                <input type="color" style="width: 100px;" class="" [(ngModel)]="objectColorCode">
                <input type="text" style="width: 250px;" class="" [(ngModel)]="objectColorCode">
              </div>
            </div>

            <div class="map-frame">
              <div id="map2">
              </div>
              <div class="map-latlng">
                <button (click)="resetEditLatLng()">{{ 'generic.reset' | translate }}</button>
                <button (click)="removeLatLng()" style="margin-left: 10px;" *ngIf="isLatLng">{{ 'generic.remove' |
                  translate }}</button>
              </div>
            </div>

            <div class="image-container" style="margin: 20px 0;">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.icon' | translate }}</h5>
                <i *ngIf="icon == null || icon == ''" (click)="addIconBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block" *ngIf="icon != null && icon != ''">
                <div class="image-single">
                  <img src="{{icon}}" alt="">
                  <span (click)="removeIcon()">{{ 'generic.remove' | translate }}</span>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-icon-btn" accept="image/*" hidden="true"
                  (change)="onIconChange($event)">
              </div>

            </div>


            <div class="image-container">
              <div class="image-header image-header1">
                <h5>{{ 'object-info.images' | translate }}</h5>
                <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
              </div>
              <div class="image-content-block">

                <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                  <p>{{image.name}}</p>
                  <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                  <button (click)="removeImage(i)">{{ 'generic.remove' | translate }}</button>
                </div>
                <div class="large-image-view" *ngIf="largeImage != ''">
                  <img src="{{largeImage}}" alt="">
                  <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                </div>
              </div>

              <div hidden="true">
                <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
                  (change)="onTicketChange($event)">
              </div>
            </div>



            <div class="multiple-inputs"
              *ngIf="nameValue && nameValue != null && nameValue != undefined && nameValue.length != 0">
              <h5 class="multi-title">{{ 'object-info.specifications' | translate }}</h5>
              <ul class="ui-tree">
                <ng-container *ngFor="let item of nameValue">
                  <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                      type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>
            </div>


            <div class="multiple-inputs" *ngIf="warranty">
              <h5 class="multi-title">{{ 'object-info.warranty' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let warrantyInfo of warrantyInfo">
                  <strong>{{ warrantyInfo.key }}:</strong>
                  <span *ngIf="warrantyInfo.key != 'Coverage Start Date' && warrantyInfo.key != 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="text">
                  </span>
                  <span *ngIf="warrantyInfo.key == 'Coverage Start Date' || warrantyInfo.key == 'Coverage End Date'">
                    <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="date">
                  </span>
                </li>
              </ul>
            </div>


            <div class="multiple-inputs" *ngIf="purchase">
              <h5 class="multi-title">{{ 'object-info.purchase' | translate }}</h5>

              <ul class="ui-tree">
                <li *ngFor="let purchaseInfo of purchaseInfo">
                  <strong>{{ purchaseInfo.key }}:</strong>
                  <span *ngIf="purchaseInfo.key != 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                      style="width: 100%;" type="text"></span>
                  <span *ngIf="purchaseInfo.key == 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                      style="width: 100%;" type="date"></span>
                </li>
              </ul>
            </div>

            <div class="check-box">
              <p><input type="checkbox" (click)="selectPerformance($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="performance" [(ngModel)]="performance">{{ 'object-info.assetPerformance' | translate }}</p>
            </div>


            <div class="nameValue" *ngIf="performance">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                <div class="row keys-content">

                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                      <input [(ngModel)]="timeSpan" [ngModelOptions]="{standalone: true}" placeholder="enter time span"
                        type="text" class="form-control">
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.uom' | translate }}</label>
                      <select class="form-control" [(ngModel)]="uom" [ngModelOptions]="{standalone: true}">
                        <option value="" selected disabled> -- Select Uom --</option>
                        <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                      <input [(ngModel)]="expectedOutput" [ngModelOptions]="{standalone: true}"
                        placeholder="enter expected output" type="text" class="form-control">
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="check-box">
              <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deployCurrentLocation" [(ngModel)]="alive">{{ 'object-info.alive' | translate }}</p>                 
            </div> -->

            <div class="check-box">
              <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deployCurrentLocation"
                  [(ngModel)]="deployCurrentLocation">{{ 'object-info.deployCurrentLocation' | translate }}</p>
            </div>


            <div class="check-box" *ngIf="list.parentAssetIdFlag">
              <p><input type="checkbox" (click)="selectParentAsset($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="isParentAssetId" [(ngModel)]="isParentAssetId">{{ 'object-info.parentAsset' | translate }}
              </p>
            </div>


            <div class="nameValue" *ngIf="isParentAssetId">
              <div>

                <div class="row keys-content">
                  <div class="col-md-12 col-lg-12 keysBlock">
                    <div class="form-group">
                      <label for="">{{ 'object-info.parentAsset' | translate }}</label>
                      <!-- <select name="" id="" [(ngModel)]="parentAssetId" class="form-control">
                        <option value="" selected disabled> -- select parent asset --</option>
                        <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
                      </select> -->
                      <ng-multiselect-dropdown [placeholder]="'Select Parent'" [settings]="parentDropdownSettings"
                        [data]="objectInfoList" [(ngModel)]="parentSelectedList" class="form-control"
                        style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="multiple-inputs" *ngIf="list.performanceMatrix && list.performanceMatrix != null && list.performanceMatrix != undefined && list.performanceMatrix.length != 0">
              <h5 class="multi-title">Performance</h5>

              <ul class="ui-tree">
                <ng-container *ngFor="let item of list.performanceMatrix">
                  <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                </ng-container>
              </ul>

              <ng-template #renderNode1 let-node>
                <li>
                  <strong>{{ node.key }}:</strong> <span><input readonly [(ngModel)]="node.value" style="width: 100%;" type="text"></span>
                  <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                    <ng-container *ngFor="let child of node.keyValue">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>

            </div> -->


            <div class="check-box">
              <p><input type="checkbox" (click)="selectConnection($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetMonitoring" [(ngModel)]="assetMonitoring"> {{ 'object-info.assetMonitoring' |
                translate }}</p>
            </div>


            <div class="nameValue" *ngIf="assetMonitoring">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringFrequency' | translate }}</label>
                    <input [(ngModel)]="assetMonitoringFrequency" disabled [ngModelOptions]="{standalone: true}"
                      type="number" class="form-control">
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <label for="">{{ 'object-info.assetMonitoringTimeSpan' | translate }} </label>
                    <input [(ngModel)]="assetMonitoringTimeSpan" disabled [ngModelOptions]="{standalone: true}"
                      type="number" class="form-control">
                  </div>
                </div>
              </div>
              <div>
                <h5 class="multi-title">{{ 'object-info.connections' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of connectionsList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" disabled (blur)="object.key = object.key.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter name" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" disabled (blur)="object.value = object.value.trim()"
                        (keydown)="filterInputByType($event, 'allText')" [ngModelOptions]="{standalone: true}"
                        placeholder="enter parameter value" type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="nameValue" *ngIf="assetMonitoring">
              <div>
                <h5 class="multi-title">NMS</h5>

                <div class="row keys-content keysBlock" style="width: 99%;margin-left: auto;margin-right: auto;">

                  <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                      <label for="">{{ 'zabbix.groups' | translate }} <span class="required"> *</span></label>
                      <select name="" id="" [disabled]="isNmsAdded" class="form-control" [(ngModel)]="groups"
                        [ngModelOptions]="{standalone: true}">
                        <option value="">Select Group</option>
                        <option *ngFor="let group of zabbixGroups" [value]="group.groupid">{{ group.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.templates' | translate }} <span class="required"> *</span></label>
                      <select name="" id="" [disabled]="isNmsAdded" class="form-control" [(ngModel)]="templates"
                        [ngModelOptions]="{standalone: true}">
                        <option value="">Select Template</option>
                        <option *ngFor="let template of zabbixTemplates" [value]="template.templateid">{{ template.name
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.ip' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="ip" [disabled]="isNmsAdded" [ngModelOptions]="{standalone: true}"
                        placeholder="enter ip" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.port' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="port" [disabled]="isNmsAdded" [ngModelOptions]="{standalone: true}"
                        placeholder="enter port" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpCommunity' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="snmpCommunity" [disabled]="isNmsAdded" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp community" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpVersion' | translate }} <span class="required"> *</span></label>
                      <input [(ngModel)]="snmpVersion" [disabled]="isNmsAdded" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp version" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 ">

                    <div class="form-group">
                      <label for="">{{ 'zabbix.snmpContextName' | translate }}</label>
                      <input [(ngModel)]="snmpContextName" [disabled]="isNmsAdded" [ngModelOptions]="{standalone: true}"
                        placeholder="enter snmp context name" type="text" class="form-control">
                    </div>

                    <div>


                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="check-box">
              <p><input type="checkbox" (click)="selectAssetHealth($event)" [ngModelOptions]="{standalone: true}"
                  [checked]="assetHealth" [(ngModel)]="assetHealth"> {{ 'object-info.assetHealth' | translate }}</p>
            </div>

            <div class="nameValue" *ngIf="assetHealth">
              <div>
                <h5 class="multi-title">{{ 'object-info.assetHealth' | translate }}</h5>

                <div class="row keys-content" *ngFor="let object of assetHealthList;let i = index;let last = last">
                  <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                    <i class="bi bi-plus-circle" (click)="addAssetHealth()"></i>
                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                    <i class="bi bi-dash-circle" (click)="removeAssetHealth(i)"></i>
                  </div>
                  <div class="col-md-11 col-lg-11 keysBlock">
                    <div class="form-group">
                      <input [(ngModel)]="object.key" [ngModelOptions]="{standalone: true}" placeholder="enter key"
                        type="text" class="form-control">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="object.value" [ngModelOptions]="{standalone: true}" placeholder="enter value"
                        type="text" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalEdit" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
          <button type="button" (click)="updateObjectInfo()" class="btn btn-primary">{{ 'generic.save' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="cloneDeviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.cloneAsset' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>

          <!-- <div class="form-group">
              <label>Asset Clone<span class="required">*</span></label>
              <select name="" id="" [(ngModel)]="objectInfoId" class="form-control"  (change)="cloneObjectInfoById($event)">
                <option value="" selected disabled> -- Asset --</option>
                <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
              </select>
          </div> -->
          <div *ngIf="isClone">

            <div class="form-group">
              <label>{{ 'object-info.name' | translate }} <span class="required">*</span></label>
              <input type="text" class="form-control" readonly [(ngModel)]="templateName">
            </div>

            <div *ngFor="let list of singleObjectTemplateData">

              <div class="form-group">
                <label>{{ 'object-info.name' | translate }} <span class="required">*</span></label>
                <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()"
                  (blur)="trimValue('givenName')" (keydown)="filterInputByType($event, 'allText')" (cut)="false"
                  class="form-control" [(ngModel)]="givenName">
              </div>




              <div class="form-group" *ngIf="originalCostCheckBox">
                <label>{{ 'object-info.originalCost' | translate }} </label>
                <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                  (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="originalCost">
              </div>

              <div class="form-group" *ngIf="currentCostCheckBox">
                <label>{{ 'object-info.currentCost' | translate }} </label>
                <input type="text" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()" (cut)="false"
                  (keydown)="filterInputByType($event, 'number')" class="form-control" [(ngModel)]="currentCost">
              </div>

              <div class="form-group">
                <label>{{ 'object-info.objectCondition' | translate }} <span class="required">*</span></label>
                <select name="" id="" [(ngModel)]="objectCondition" class="form-control">
                  <option value="" selected disabled> -- Select Condition --</option>
                  <option value="Good">Good</option>
                  <option value="UnderRepair">Under Repair</option>
                  <option value="Scrap">Scrap</option>
                </select>
              </div>


              <div class="form-group">
                <label>{{ 'object-info.assetStatus' | translate }}</label>
                <select name="" id="" [(ngModel)]="assetStatus" class="form-control">
                  <option value=""> -- </option>
                  <option *ngFor="let list of assetStatusList" [value]="list.name">{{ list.name }}</option>
                </select>
              </div>
              <!-- 
              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.asset_Category' | translate }} <span class="required"
                    *ngIf="isAsset_Category">*</span></label>
                <select name="" id="" [(ngModel)]="asset_Category" class="form-control">
                  <option value="" selected disabled> -- Select Asset Category--</option>
                  <option value="{{list.categoryName}}" *ngFor="let list of objectCategoryList">{{list.categoryName}}
                  </option>
                </select>
              </div>

              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.acquisitionDate' | translate }}</label>
                <input type="date" (keydown)="filterDateInput($event)" class="form-control"
                  [(ngModel)]="acquisitionDate">
              </div>

              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.salvageValue' | translate }} <span class="required"
                    *ngIf="isSalvageValue">*</span></label>
                <input type="number" class="form-control" [(ngModel)]="salvageValue">
              </div>

              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.depreciationMethod' | translate }}</label>
                <select name="" id="" [(ngModel)]="depreciationMethod"
                  (change)="depreciationMethodChange(depreciationMethod)" class="form-control">
                  <option value="" selected disabled> -- Select Asset Depreciation--</option>
                  <option value="{{list.assetDepreciationMethodId}}" *ngFor="let list of assetDepreciationDataList">
                    {{list.methodName}}</option>
                </select>
              </div>

              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.putToUseDate' | translate }} <span class="required"
                    *ngIf="isPutToUseDate">*</span></label>
                <input type="date" [max]="todayDate" (keydown)="filterDateInput($event)" class="form-control"
                  [(ngModel)]="putToUseDate">
              </div>

              <div class="form-group" *ngIf="list.depreciationRequired">
                <label>{{ 'object-info.assetLifeNumber' | translate }} <span class="required"
                    *ngIf="isAssetLifeNumber">*</span></label>
                <input type="number" class="form-control" (paste)="false" (contextmenu)="$event.preventDefault()"
                  (cut)="false" (keydown)="filterInputByType($event, 'number')" [(ngModel)]="assetLifeNumber">
              </div> -->

              <div class="form-group" *ngIf="list.branch">
                <label>{{ 'object-info.branch' | translate }}</label>
                <select name="" id="" [(ngModel)]="branch" class="form-control">
                  <option value="" selected disabled> -- Select Branch --</option>
                  <option value="{{list.name}}" *ngFor="let list of branchList">{{list.name}}</option>
                </select>
              </div>

              <div class="form-group" *ngIf="list.department">
                <label>{{ 'object-info.department' | translate }}</label>
                <select name="" id="" [(ngModel)]="department" class="form-control">
                  <option value="" selected disabled> -- Select Department--</option>
                  <option value="{{list.departmentName}}" *ngFor="let list of departmentInfoList">
                    {{list.departmentName}}</option>
                </select>
              </div>

              <div class="form-group" *ngIf="list.make">
                <label>{{ 'object-info.make' | translate }}</label>
                <input type="text" class="form-control" (blur)="trimValue('make')"
                  (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="make">
              </div>

              <div class="form-group" *ngIf="list.model">
                <label>{{ 'object-info.model' | translate }}</label>
                <input type="text" class="form-control" (blur)="trimValue('model')"
                  (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="model">
              </div>

              <div class="form-group" *ngIf="list.serialNumber">
                <label>{{ 'object-info.serialNumber' | translate }}</label>
                <input type="text" class="form-control" (blur)="trimValue('serialNumber')"
                  (keydown)="filterInputByType($event, 'allText')" [(ngModel)]="serialNumber">
              </div>



              <div class="form-group" *ngIf="list.quantity">
                <label>{{ 'object-info.objectQty' | translate }}</label>
                <input type="text" class="form-control" [(ngModel)]="objectQty">
              </div>

              <div class="form-group" *ngIf="list.quantity">
                <label>{{ 'object-info.objectUOM' | translate }}</label>
                <select class="form-control" [(ngModel)]="objectUOM" [ngModelOptions]="{standalone: true}">
                  <option value="" selected disabled> -- Select Uom --</option>
                  <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}</option>
                </select>
              </div>

              <!-- <div class="form-group" >
              <label>{{ 'object-info.availableQty' | translate }}</label>
              <input type="text" class="form-control" [(ngModel)]="availableQty">
            </div> -->

              <div class="form-group">
                <label>{{ 'object-info.location' | translate }} <span class="required">*</span></label>
                <select name="" id="" [(ngModel)]="location" class="form-control">
                  <option value="" selected disabled> -- Select Location --</option>
                  <option value="{{list.zone}}" *ngFor="let list of locationFilterList">{{list.zone}} - {{list.city}} -
                    {{list.postalCode}}</option>
                </select>
              </div>

              <div class="map-frame">
                <div id="map1">
                </div>
                <div class="map-latlng">
                  <button (click)="resetEditLatLng()">{{ 'generic.reset' | translate }}</button>
                  <button (click)="removeLatLng()" style="margin-left: 10px;" *ngIf="isLatLng">{{ 'generic.remove' |
                    translate }}</button>
                </div>
              </div>


              <div class="image-container" style="margin: 20px 0;">
                <div class="image-header image-header1">
                  <h5>{{ 'object-info.icon' | translate }}</h5>
                  <i *ngIf="icon == ''" (click)="addIconBtn()" class="bi bi-plus-circle"></i>
                </div>
                <div class="image-content-block" *ngIf="icon != null && icon != ''">
                  <div class="image-single">
                    <img src="{{icon}}" alt="">
                    <span (click)="removeIcon()">{{ 'generic.remove' | translate }}</span>
                  </div>
                </div>

                <div hidden="true">
                  <input #imageInput type="file" id="add-icon-btn" accept="image/*" hidden="true"
                    (change)="onIconChange($event)">
                </div>

              </div>


              <div class="image-container">
                <div class="image-header image-header1">
                  <h5>{{ 'object-info.images' | translate }}</h5>
                  <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
                </div>
                <!-- <div class="image-content-block">
              <div class="image-single" *ngFor="let image of imagesWithDetails">
                <img src="{{image}}" (click)="selectLargeImage(image)" alt="">
              </div>
              <div class="large-image-view" *ngIf="largeImage != ''">
                <img src="{{largeImage}}" alt="">
                <button (click)="selectLargeImage('')">close</button>
              </div>
            </div> -->

                <div class="image-content-block">

                  <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                    <p>{{image.name}}</p>
                    <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                    <button (click)="removeImage(i)">{{ 'generic.remove' | translate }}</button>
                  </div>
                  <div class="large-image-view" *ngIf="largeImage != ''">
                    <img src="{{largeImage}}" alt="">
                    <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                  </div>
                </div>

                <div hidden="true">
                  <input #imageInput type="file" id="add-TicketImage-btn" accept="image/*" hidden="true"
                    (change)="onTicketChange($event)">
                </div>
              </div>









              <div class="check-box">
                <p> {{ 'maintenance-schedule.title' | translate }} <i (click)="addMaintenance()"
                    class="bi bi-plus-circle"></i></p>
              </div>

              <div class="maintenance-schedule-block">
                <!-- <h5>Maintenance Schedule</h5> -->
                <div class="maintenance-schedule" *ngFor="let list of maintenanceList;let index = index">
                  <span class="remove"><i (click)="removeMaintenance(index)" class="bi bi-x-lg"></i></span>

                  <div class="form-group">
                    <label>{{ 'maintenance-schedule.description' | translate }}</label>
                    <textarea name="" [(ngModel)]="list.description" class="form-control" id=""></textarea>
                  </div>

                  <div class="form-group">
                    <label>{{ 'maintenance-schedule.maintenanceType' | translate }}</label>
                    <select name="" id="" [(ngModel)]="list.maintenanceType" class="form-control">
                      <option value="" selected disabled> -- Select Maintenance Type --</option>
                      <option value="{{list.value}}" *ngFor="let list of maintenanceType">{{list.key}}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>{{ 'maintenance-schedule.frequency' | translate }}</label>
                    <select name="" id="" [(ngModel)]="list.frequency" class="form-control">
                      <option value="" selected disabled> -- Select Frequency Type --</option>
                      <option value="{{list.value}}" *ngFor="let list of frequencyType">{{list.key}}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>{{ 'maintenance-schedule.nextDueDate' | translate }}</label>
                    <input type="date" [min]="todayDate" class="form-control" [(ngModel)]="list.nextDueDate">
                  </div>
                </div>
              </div>

              <div class="multiple-inputs"
                *ngIf="nameValue && nameValue != null && nameValue != undefined && nameValue.length != 0">
                <h5 class="multi-title">{{ 'object-info.specifications' | translate }}</h5>
                <ul class="ui-tree">
                  <ng-container *ngFor="let item of nameValue">
                    <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                        type="text"></span>
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>
              </div>

              <div class="multiple-inputs"
                *ngIf="performanceMatrix && performanceMatrix != null && performanceMatrix != undefined && performanceMatrix.length != 0">
                <h5 class="multi-title">{{ 'object-info.performance' | translate }}</h5>

                <ul class="ui-tree">
                  <ng-container *ngFor="let item of performanceMatrix">
                    <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                  </ng-container>
                </ul>

                <ng-template #renderNode1 let-node>
                  <li>
                    <strong>{{ node.key }}:</strong> <span><input [(ngModel)]="node.value" style="width: 100%;"
                        type="text"></span>
                    <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                      <ng-container *ngFor="let child of node.keyValue">
                        <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                      </ng-container>
                    </ul>
                  </li>
                </ng-template>

              </div>




              <div class="multiple-inputs" *ngIf="warranty">
                <h5 class="multi-title">{{ 'object-info.warranty' | translate }}</h5>

                <ul class="ui-tree">
                  <li *ngFor="let warrantyInfo of warrantyInfo">
                    <strong>{{ warrantyInfo.key }}:</strong>
                    <span *ngIf="warrantyInfo.key != 'Coverage Start Date' && warrantyInfo.key != 'Coverage End Date'">
                      <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="text">
                    </span>
                    <span *ngIf="warrantyInfo.key == 'Coverage Start Date' || warrantyInfo.key == 'Coverage End Date'">
                      <input [(ngModel)]="warrantyInfo.value" style="width: 100%;" type="date">
                    </span>
                  </li>
                </ul>
              </div>


              <div class="multiple-inputs" *ngIf="purchase">
                <h5 class="multi-title">{{ 'object-info.purchase' | translate }}</h5>

                <ul class="ui-tree">
                  <li *ngFor="let purchaseInfo of purchaseInfo">
                    <strong>{{ purchaseInfo.key }}:</strong>
                    <span *ngIf="purchaseInfo.key != 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                        style="width: 100%;" type="text"></span>
                    <span *ngIf="purchaseInfo.key == 'Invoice Date'"><input [(ngModel)]="purchaseInfo.value"
                        style="width: 100%;" type="date"></span>
                  </li>
                </ul>
              </div>


              <div class="check-box">
                <p><input type="checkbox" (click)="selectConnection($event)" [ngModelOptions]="{standalone: true}"
                    [checked]="assetMonitoring" [(ngModel)]="assetMonitoring"> {{ 'object-info.assetMonitoring' |
                  translate }}</p>
              </div>


              <div class="nameValue" *ngIf="assetMonitoring">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="">{{ 'object-info.assetMonitoringFrequency' | translate }}</label>
                      <input [(ngModel)]="assetMonitoringFrequency" [ngModelOptions]="{standalone: true}" type="number"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="">{{ 'object-info.assetMonitoringTimeSpan' | translate }}</label>
                      <input [(ngModel)]="assetMonitoringTimeSpan" [ngModelOptions]="{standalone: true}" type="number"
                        class="form-control">
                    </div>
                  </div>
                </div>
                <div>
                  <h5 class="multi-title">{{ 'object-info.connections' | translate }}</h5>

                  <div class="row keys-content" *ngFor="let object of connectionsList;let i = index;let last = last">
                    <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                      <i class="bi bi-plus-circle" (click)="addConnection()"></i>
                      <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeConnection(i)"></i>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                      <i class="bi bi-dash-circle" (click)="removeConnection(i)"></i>
                    </div>
                    <div class="col-md-11 col-lg-11 keysBlock">
                      <div class="form-group">
                        <input [(ngModel)]="object.key" [ngModelOptions]="{standalone: true}"
                          placeholder="enter parameter name" type="text" class="form-control">
                      </div>
                      <div class="form-group">
                        <input [(ngModel)]="object.value" [ngModelOptions]="{standalone: true}"
                          placeholder="enter parameter value" type="text" class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="nameValue" *ngIf="assetMonitoring">
                <div>
                  <h5 class="multi-title">{{ 'zabbix.headings.add' | translate }}</h5>

                  <div class="row keys-content keysBlock" style="width: 99%;margin-left: auto;margin-right: auto;">

                    <div class="col-md-6 col-lg-6 ">
                      <div class="form-group">
                        <label for="">{{ 'zabbix.groups' | translate }} <span class="required"> *</span></label>
                        <select name="" id="" class="form-control" [(ngModel)]="groups"
                          [ngModelOptions]="{standalone: true}">
                          <option value="">Select Group</option>
                          <option *ngFor="let group of zabbixGroups" [value]="group.groupid">{{ group.name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.templates' | translate }} <span class="required"> *</span></label>
                        <select name="" id="" class="form-control" [(ngModel)]="templates"
                          [ngModelOptions]="{standalone: true}">
                          <option value="">Select Template</option>
                          <option *ngFor="let template of zabbixTemplates" [value]="template.templateid">{{
                            template.name
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.ip' | translate }} <span class="required"> *</span></label>
                        <input [(ngModel)]="ip" [ngModelOptions]="{standalone: true}" placeholder="enter ip" type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.port' | translate }} <span class="required"> *</span></label>
                        <input [(ngModel)]="port" [ngModelOptions]="{standalone: true}" placeholder="enter port"
                          type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.snmpCommunity' | translate }} <span class="required"> *</span></label>
                        <input [(ngModel)]="snmpCommunity" [ngModelOptions]="{standalone: true}"
                          placeholder="enter snmp community" type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.snmpVersion' | translate }} <span class="required"> *</span></label>
                        <input [(ngModel)]="snmpVersion" [ngModelOptions]="{standalone: true}"
                          placeholder="enter snmp version" type="text" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 ">

                      <div class="form-group">
                        <label for="">{{ 'zabbix.snmpContextName' | translate }}</label>
                        <input [(ngModel)]="snmpContextName" [ngModelOptions]="{standalone: true}"
                          placeholder="enter snmp context name" type="text" class="form-control">
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <div class="check-box">
                <p><input type="checkbox" (click)="selectAssetHealth($event)" [ngModelOptions]="{standalone: true}"
                    [checked]="assetHealth" [(ngModel)]="assetHealth"> {{ 'object-info.assetHealth' | translate }}</p>
              </div>


              <div class="nameValue" *ngIf="assetHealth">
                <div>
                  <h5 class="multi-title">{{ 'object-info.assetHealth' | translate }}</h5>

                  <div class="row keys-content" *ngFor="let object of assetHealthList;let i = index;let last = last">
                    <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                      <i class="bi bi-plus-circle" (click)="addAssetHealth()"></i>
                      <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeAssetHealth(i)"></i>
                    </div>
                    <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                      <i class="bi bi-dash-circle" (click)="removeAssetHealth(i)"></i>
                    </div>
                    <div class="col-md-11 col-lg-11 keysBlock">
                      <div class="form-group">
                        <input [(ngModel)]="object.key" [ngModelOptions]="{standalone: true}"
                          placeholder="enter parameter name" type="text" class="form-control">
                      </div>
                      <div class="form-group">
                        <input [(ngModel)]="object.value" [ngModelOptions]="{standalone: true}"
                          placeholder="enter parameter value" type="text" class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="check-box">
                <p><input type="checkbox" (click)="selectPerformance($event)" [ngModelOptions]="{standalone: true}"
                    [checked]="performance" [(ngModel)]="performance"> {{ 'object-info.assetPerformance' | translate }}
                </p>
              </div>


              <div class="nameValue" *ngIf="performance">
                <div>
                  <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                  <div class="row keys-content">

                    <div class="col-md-12 col-lg-12 keysBlock">
                      <div class="form-group">
                        <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                        <input [(ngModel)]="timeSpan" [ngModelOptions]="{standalone: true}"
                          placeholder="enter time span" type="text" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.uom' | translate }}</label>
                        <select class="form-control" [(ngModel)]="uom" [ngModelOptions]="{standalone: true}">
                          <option value="" selected disabled> -- Select Uom --</option>
                          <option value="{{uom.uomName}}" *ngFor="let uom of uomData;let i = index">{{uom.uomName}}
                          </option>
                        </select>
                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                        <input [(ngModel)]="expectedOutput" [ngModelOptions]="{standalone: true}"
                          placeholder="enter expected output" type="text" class="form-control">
                      </div>

                    </div>
                  </div>
                </div>
              </div>


              <div class="check-box">
                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deployCurrentLocation"
                    [(ngModel)]="deployCurrentLocation">{{ 'object-info.deployCurrentLocation' | translate }}</p>
              </div>


              <div class="check-box">
                <p><input type="checkbox" (click)="selectParentAsset($event)" [ngModelOptions]="{standalone: true}"
                    [checked]="isParentAssetId" [(ngModel)]="isParentAssetId">{{ 'object-info.parentAsset' | translate
                  }}</p>
              </div>


              <div class="nameValue" *ngIf="isParentAssetId">
                <div>

                  <div class="row keys-content">

                    <div class="col-md-12 col-lg-12 keysBlock">
                      <div class="form-group">
                        <label for="">{{ 'object-info.parentAsset' | translate }}</label>
                        <select name="" id="" [(ngModel)]="parentAssetId" class="form-control">
                          <option value="" selected disabled> -- Select Parent Asset --</option>
                          <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>




              <div class="check-box">
                <p>{{ 'object-info.tags' | translate }} <i (click)="addTag()" class="bi bi-plus-circle"></i></p>
              </div>

              <div class="tags-block">
                <div class="form-group tag" *ngFor="let list of tags;let index = index">
                  <input type="text" placeholder="enter tag" [(ngModel)]="list.tag" class="form-control">
                  <span class="remove"><i (click)="removeTag(index)" class="bi bi-x-lg"></i></span>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButtonClone" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addObjectInfo()" class="btn btn-primary">{{ 'generic.save' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="printModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Print
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div id="print-section">
          <div class="print-section-block">
            <div class="print-data">
              <p>ID: <span>{{singleObjectInfoData[0]?.objectInfoId}}</span></p>
              <p>{{singleObjectInfoData[0]?.givenName}}</p>
              <p>Location: <span>{{singleObjectInfoData[0]?.location}}</span></p>
            </div>
            <div>
              <qrcode [qrdata]="jsonString" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" id="" class="btn btn-primary" (click)="print('print-section')">Print</button>
          <button type="button" id="closeModalButtonClone" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <div class="modal fade" id="viewRole" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'object-template.headings.detail' | translate }}
                    <span data-dismiss="modal">
                        <i (click)="remove()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group" *ngFor="let template of singleTemplate">
                    <div class="row">
                   




                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton3" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.close' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div> -->











<div class="modal fade" id="viewHoldingModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" *ngFor="let viewData of singleObjectInfoData">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.holdingDetails' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="remove()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data">
          <div class="form-group">
            <div class="row">
              <div class="col-md-12 col-lg-12 switch-ports-wrapper">
                <div class="card">
                  <div class="card-header">
                    <div class="title">
                      <div class="icon-box">
                        <i class="fa-solid fa-clipboard-list"></i>
                      </div>
                      <h2>{{ 'object-info.holdingDetails' | translate }}</h2>
                    </div>
                  </div>

                  <div class="table-wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th>{{ 'object-allocation-register.userId' | translate }}</th>
                          <th>{{ 'object-info.holding' | translate }}</th>
                          <th>{{ 'object-allocation-register.updatedDate' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let holding of viewData.holding">
                          <td>{{ holding.userId || '--' }}</td>
                          <td>{{ holding?.name || '--' }}</td>
                          <td>{{ (holding.date | date:'medium') || '--' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="table-footer">
                    Showing 1 to {{ viewData.holding?.length || 0 }} of {{ viewData.holding?.length || 0 }} entries
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeHoldingModalButton" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- <button (click)="getHostById(10788)">host</button> -->